
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
    abandoned: {
      type: Boolean,
      default: false,
    },
    postponed: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
    };
  },
  computed: {
    scoreline () {
      return this.getFixtureScore(this.fixture);
    },
    halfTimeScore () {
      if (this.homeTeam.halfTimeScore !== null && this.awayTeam.halfTimeScore !== null) {
        return [this.homeTeam.halfTimeScore, this.awayTeam.halfTimeScore];
      }
      return null;
    },
    homeTeam () {
      return this.getTeam(this.fixture, `Home`);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
  },
};
